module.exports = __webpack_public_path__ + "static/img/icon_house.a94bed1.png";